/**
 * マーク・アイコンマスタ画面のマークファイルクラス
 *
 * @export MarkFileForView
 * @class MarkFileForView
 */
export class MarkFileForView {
    public check = false;
    constructor(
        public delivEndDate: string,
        public markGroupCode: string,
        public markGroupName: string,
        public markCode: string,
        public markCodeBranch: string,
        public markName: string,
        public markFileUrl: string,
        public markFileName: string,
        public startOrderCode: string,
        public startDelivCatalogId: string,
        public endOrderCode: string,
        public endDelivCatalogId: string,
        public supplyPromoteMarkDiv: string,
        public registDate: string,
        public fileRegistDate: string,
        // 使用終了判定用フラグ
        public delivEndFlg: boolean
    ) { }
}
